import React, { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { motion } from "framer-motion";
import { BookOpen, Clock, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function Education() {
  const { t, lang } = useApp();
  const [articles, setArticles] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => { api.get("/education/articles").then(({ data }) => setArticles(data)); }, []);

  return (
    <div className="min-h-screen bg-[#F9F8F6] grain-bg pb-16">
      <div className="max-w-7xl mx-auto px-6 pt-12">
        <div className="mb-12 max-w-3xl">
          <div className="label-eco mb-3"><BookOpen size={12} className="inline mr-1" /> Knowledge base</div>
          <h1 className="text-5xl font-black tracking-tight text-[#17301C]">{t.education.title}</h1>
          <p className="text-lg text-[#3A4A3E] mt-3">{t.education.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {articles.map((a, i) => (
            <motion.button
              key={a.id}
              onClick={() => setSelected(a)}
              data-testid={`article-${a.id}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="card-surface p-6 text-left hover:border-[#17301C]"
            >
              <div className="text-xs uppercase tracking-widest font-bold text-[#EAB308] mb-3">{a.category}</div>
              <h3 className="text-xl font-black text-[#17301C] leading-tight mb-3">{lang === "it" ? a.title_it : a.title_en}</h3>
              <p className="text-sm text-[#3A4A3E] leading-relaxed line-clamp-3">{lang === "it" ? a.excerpt_it : a.excerpt_en}</p>
              <div className="mt-4 flex items-center gap-1 text-xs text-[#6E7A71]">
                <Clock size={12} /> {a.read_min} {t.education.read_min}
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      <Dialog open={!!selected} onOpenChange={(o) => !o && setSelected(null)}>
        <DialogContent className="bg-white max-w-2xl max-h-[80vh] overflow-y-auto">
          {selected && (
            <>
              <DialogHeader>
                <div className="text-xs uppercase tracking-widest font-bold text-[#EAB308] mb-1">{selected.category}</div>
                <DialogTitle className="text-3xl font-black text-[#17301C] leading-tight">{lang === "it" ? selected.title_it : selected.title_en}</DialogTitle>
              </DialogHeader>
              <div className="text-[#3A4A3E] leading-relaxed whitespace-pre-line mt-4">
                {lang === "it" ? selected.body_it : selected.body_en}
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
